var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bonus"
  }, [_c('div', {
    staticClass: "bonus__wrap"
  }, [_vm.quantity > 0 ? _c('div', [_c('div', {
    staticClass: "bonus__title"
  }, [_vm._v("\n        Войдите, чтобы получить\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "bonus__description"
  }, [_c('div', {
    staticClass: "bonus__count"
  }, [_vm._v("\n          " + _vm._s(_vm.beautyBonusCountText) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "bonus__text"
  }, [_vm._v("за заказ")])])]) : _c('div', {
    staticClass: "bonus__title"
  }, [_vm._v("\n      Войдите, чтобы воспользоваться бонусами\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "bonus__button"
  }, [_c('Button', {
    attrs: {
      "size": "39",
      "theme": "white",
      "fluid": ""
    },
    on: {
      "click": function ($event) {
        return _vm.enable();
      }
    }
  }, [_vm._v("\n        Войти\n      ")])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }